module.exports = __webpack_public_path__ + "static/img/6686_phase_function_Paper_Points.5a3926b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6686_phase_function_Paper_Points.png
// module id = pW9f
// module chunks = 0